var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarEmpty = function SvgStarEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 10 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.14,
    d: "M5.269.74a.63.63 0 0 0-.538 0 .65.65 0 0 0-.27.259c-.041.069-.085.157-.127.242l-.898 1.82-2.01.294c-.094.014-.191.028-.27.047a.65.65 0 0 0-.329.176.63.63 0 0 0-.166.511.65.65 0 0 0 .163.336c.053.062.123.13.192.197l1.453 1.415-.343 2c-.016.094-.033.19-.04.271a.65.65 0 0 0 .067.368c.09.165.25.282.435.316a.65.65 0 0 0 .37-.051c.074-.031.161-.077.246-.122L5 7.876l1.796.945c.085.044.172.09.246.12.073.03.21.082.37.052a.63.63 0 0 0 .436-.316.65.65 0 0 0 .065-.368c-.006-.08-.023-.177-.039-.271l-.343-2 1.453-1.415c.069-.067.14-.135.192-.197a.65.65 0 0 0 .163-.336.63.63 0 0 0-.166-.511.65.65 0 0 0-.33-.176c-.078-.02-.175-.033-.27-.047L6.564 3.06l-.898-1.82c-.042-.085-.086-.173-.128-.242a.65.65 0 0 0-.269-.26"
  })));
};
export default SvgStarEmpty;